import React from 'react'
import ReactDOM from 'react-dom'
import AppDocs from 'app/AppDocs.jsx'

import 'app/assets/scss/index.scss'

const pkgPath = '/home/lapis/repos/gh/arredemo'

const pkgJson = JSON.parse(`
  {
  "name": "arredemo",
  "version": "1.2.1",
  "description": "Instantly build a static site for your package",
  "type": "module",
  "bin": "bin/arre.mjs",
  "imports": {
    "#app/*": "./src/app/*",
    "#scripts/*": "./src/scripts/*"
  },
  "exports": {
    "./cli": "./src/cli.mjs"
  },
  "files": [
    "bin",
    "src",
    ".babelrc.js"
  ],
  "scripts": {
    "site-clean": "rm -fr arredemo",
    "site-build": "npm run site-clean && node bin/arre.mjs build",
    "reset": "npm run site-clean && npm cache clean --force && rm -fr package-lock.json && rm -fr node_modules && npm i --ignore-scripts && npm run test-custom-reset && npm run test-noreact-reset ",
    "lint": "eslint ./src/**.mjs",
    "test-custom-reset": "cd test/arredemo-custom-test && npm run --silent x-reset",
    "test-noreact-reset": "cd test/arredemo-noreact-test  && npm run --silent x-reset",
    "test-custom": "cd test/arredemo-custom-test && npm run x-run",
    "test-noreact": "cd test/arredemo-noreact-test  && npm run x-run",
    "test": "npm run test-custom && npm run test-noreact",
    "prepare": "npm run lint && npm run site-build"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/afialapis/arredemo.git"
  },
  "author": "donato@afialapis.com",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/afialapis/arredemo/issues"
  },
  "homepage": "https://github.com/afialapis/arredemo#readme",
  "dependencies": {
    "@babel/core": "^7.26.10",
    "@babel/eslint-parser": "^7.27.0",
    "@babel/preset-env": "^7.26.9",
    "@babel/preset-react": "^7.26.3",
    "@eslint/compat": "^1.2.7",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.23.0",
    "@rollup/plugin-alias": "^5.1.1",
    "@rollup/plugin-babel": "^6.0.4",
    "@rollup/plugin-commonjs": "^28.0.3",
    "@rollup/plugin-json": "^6.1.0",
    "@rollup/plugin-node-resolve": "^16.0.1",
    "@rollup/plugin-replace": "^6.0.2",
    "@rollup/plugin-terser": "^0.4.4",
    "babel-plugin-module-resolver": "^5.0.2",
    "cross-spawn": "^7.0.6",
    "eslint": "^9.23.0",
    "eslint-plugin-react": "^7.37.4",
    "eslint-plugin-react-hooks": "^5.2.0",
    "globals": "^16.0.0",
    "markdown-to-jsx": "^7.7.4",
    "mustache": "^4.2.0",
    "node-fetch": "^3.3.2",
    "postcss": "^8.5.3",
    "prompts": "^2.4.2",
    "react": "^19.0.0",
    "react-dom": "^19.0.0",
    "rollup": "^4.37.0",
    "rollup-plugin-copy": "^3.5.0",
    "rollup-plugin-postcss": "^4.0.2",
    "sass": "^1.86.0",
    "tinguir": "^0.0.7"
  },
  "engines": {
    "node": ">=21"
  }
}
`)

const arreConfig = JSON.parse(`
{
  "theme": "default",
  "company": "Afialapis",
  "company_url": "https://www.afialapis.com",
  "url": "https://www.afialapis.com/os/arredemo",
  "doc_versions": [],
  "md": {
    "md_keep_summary_content": true,
    "md_strip_details_tag": false
  },
  "demo_entry": "",
  "has_demo": false,
  "logo": {
    "ok": true,
    "src": "logo/arredemo.png",
    "dest": "logo.png"
  },
  "favicon": {
    "main": {
      "ok": true,
      "src": "logo/favicon/arredemo.png",
      "dest": "favicon.png"
    },
    "ico": {
      "ok": true,
      "src": "logo/favicon/arredemo.ico",
      "dest": "favicon.ico"
    },
    "apple": {
      "ok": true,
      "src": "logo/favicon/arredemo_apple.png",
      "dest": "favicon_apple.png"
    }
  }
}
`)

const md_1_2_1 = decodeURIComponent(escape(window.atob(`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`)));


const readmes = {
"1.2.1": md_1_2_1,
}



ReactDOM.render(
  <AppDocs 
    pkgPath = {pkgPath}
    pkgJson = {pkgJson}
    arreConfig = {arreConfig}
    readmes = {readmes}      
  />,
  document.getElementById('arredemo-app'))

/*

// React 18

ReactDOM.createRoot(document.getElementById("arredemo-app")).render(
  <React.StrictMode>
    <AppDocs 
      pkgPath = {pkgPath}
      pkgJson = {pkgJson}
      arreConfig = {arreConfig}
      readmes = {readmes}      
    />
  </React.StrictMode>
);
*/

